import React, { useEffect } from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import FormImageSelect from '../FormImageSelect';
import { InitialMapImage } from '../../reducers/map/mapReducer';
import Button from '../UI/Button';

interface MapImageFormProps {
    externalData: InitialMapImage,
    onSubmit: (data:InitialMapImage) => void,

}

const MapImageForm = ({ externalData, onSubmit }: MapImageFormProps) => {
    const {
        register,
        handleSubmit,
        control,
        reset,
        ...methods
    } = useForm<InitialMapImage>({ defaultValues: externalData });

    useEffect(() => {
        reset(externalData);
    }, [externalData]);
    return (
        <div className='grow'>
            <FormProvider
                register={register}
                handleSubmit={handleSubmit}
                control={control}
                reset={reset}
                {...methods}
            >
                <form onSubmit={handleSubmit(onSubmit)}>
                    <label htmlFor="image">Image</label>
                    <FormImageSelect
                        name="image"
                        rules={{ required: true }}
                        type="map-image"
                    />
                    <Button
                        className='mb-3'
                        type="submit"
                    >
                        Submit
                    </Button>
                </form>
            </FormProvider>
        </div>
    );
};
export default MapImageForm;
